module.exports = __webpack_public_path__ + "img/bold.71f24f3f.svg";